var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 2.91982L19.89 5.53982C21.59 6.28982 21.59 7.52982 19.89 8.27982L13.99 10.8998C13.32 11.1998 12.22 11.1998 11.55 10.8998L5.65 8.27982C3.95 7.52982 3.95 6.28982 5.65 5.53982L11.55 2.91982C12.22 2.61982 13.32 2.61982 13.99 2.91982Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97656 11C3.97656 11.84 4.60656 12.81 5.37656 13.15L12.1666 16.17C12.6866 16.4 13.2766 16.4 13.7866 16.17L20.5766 13.15C21.3466 12.81 21.9766 11.84 21.9766 11",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97656 16C3.97656 16.93 4.52656 17.77 5.37656 18.15L12.1666 21.17C12.6866 21.4 13.2766 21.4 13.7866 21.17L20.5766 18.15C21.4266 17.77 21.9766 16.93 21.9766 16",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.a4aad53241210e3c70d9de0ca773e8f1.svg";
export { ForwardRef as ReactComponent };